import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { Configuration } from '../../app.constants';

export class Tab {
  id: number;
  text: string;
  icon: string;
  content:string;
  save:boolean;
}
let tabs: Tab[] = [
  {
    id: 1,
    text: "Personal Info i",
    icon: "user",
    content:'personalinfromation',
    save:false

  },

  {
    id: 2,
    text: "Personal Info ii",
    icon: "user",
    content:'otherdetailsform',
    save:false

  },
  {
    id: 3,
    text: "Address",
    icon: "map",
    content:'contactdetailsform',
    save:false


  }
  ,
  {
    id: 4,
    text: "Photo & Signature",
    icon: "image",
    content:'photoandsign',
    save:false


  },
  {
    id: 5,
    text: "Education Details",
    icon: "doc",
    content:'educationaldetails',
    save:false

  }
  ,
  {
    id: 6,
    text: "Social Reservation ",
    icon: "doc",
    content:'socialreservation',
    save:false

  }
  ,

  {
    id: 7,
    text: "Common Documents",
    icon: "doc",
    content:'commondocuments',
    save:false

  }
];
let tabsMarathi: Tab[] = [
  {
    id: 1,
    text: "वैयक्तिक माहिती I",
    icon: "user",
    content:'personalinfromation',
    save:false

  },

  {
    id: 2,
    text: "वैयक्तिक माहिती II",
    icon: "user",
    content:'otherdetailsform',
    save:false

  },
  {
    id: 3,
    text: "पत्ता",
    icon: "map",
    content:'contactdetailsform',
    save:false
  }
  ,
  {
    id: 4,
    text: "फोटो आणि स्वाक्षरी",
    icon: "image",
    content:'photoandsign',
    save:false


  },
  {
    id: 5,
    text: "शैक्षणिक तपशील",
    icon: "doc",
    content:'educationaldetails',
    save:false

  }
  ,
  {
    id: 6,
    text: "सामाजिक आरक्षण",
    icon: "doc",
    content:'socialreservation',
    save:false

  }
  ,

  {
    id: 7,
    text: "सामान्य कागदपत्रे",
    icon: "doc",
    content:'commondocuments',
    save:false

  }
];
export class SocialReservation {
  SocialReservationID: number;
  SocialReservationName: string;
}

export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
  visible:boolean;
};

let gridColumns: GridColumns[] = [
  {
    "caption": '#',
    "dataField": "SocialReservationID",
    "width":50,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Social Reservation Name',
    "dataField": "SocialReservationName",
    "width": 600,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": true,
    "visible":true
  },
];

let socialreservation: SocialReservation[] = [{
  "SocialReservationID": 1,
  "SocialReservationName": "Not Applicable"
},
  {
    "SocialReservationID": 2,
    "SocialReservationName": "SC"
  },
  {
    "SocialReservationID": 3,
    "SocialReservationName": "ST"
  },
  {
    "SocialReservationID": 4,
    "SocialReservationName": "OBC"
  },
];
export class EducationalDetails {
  EducationalDetailID: number;
  EducationType: string;
  ExamName: string;
  UniversityName: string;
  EducationalStream: string;
  ExamMonth: string;
  ExamYear: string;
  ExamPercentage: number;
  ExamSeatNo: string;
  MarksObtained: number;
  OutOfMarks: number;
  ExamGrade: string;
  SchoolName: string;
}


let edugridColumns: GridColumns[] = [
  {
    "caption": 'Education Type',
    "dataField": "PreviousCategory",
    "width":90,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Previous Exam/ Degree',
    "dataField": "CourseName",
    "width": 90,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'University/ Board',
    "dataField": "UniversityName",
    "width": 200,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Educational Stream',
    "dataField": "EducationalStreamName",
    "width": 95,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Year of Passing',
    "dataField": "PreviousExamYear",
    "width": 80,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Month of Passing',
    "dataField": "PreviousExamMonth",
    "width": 80,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Seat No.',
    "dataField": "PreviousExamSeatNo",
    "width": 80,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Total Marks Obtained',
    "dataField": "Obtmarks",
    "width": 80,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Out of',
    "dataField": "Maxmarks",
    "width": 70,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Percentage',
    "dataField": "PreviousExamPercentage",
    "width": 100,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Grade',
    "dataField": "PreviousGrade",
    "width": 60,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Name of School/ College',
    "dataField": "PreviousCollegeSchoolName",
    "width": 80,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
];

let educationaldetails: EducationalDetails[] = [
  {
    'EducationalDetailID': 1,
    'EducationType': 'X',
    'EducationalStream': '',
    'ExamName': '',
    'UniversityName': '',
    'ExamYear': '',
    'ExamMonth': '',
    'ExamSeatNo': '',
    'MarksObtained':null,
    'OutOfMarks': null,
    'ExamPercentage':null,
    'ExamGrade': '',
    'SchoolName': ''
  },
  {
    'EducationalDetailID': 2,
    'EducationType': 'XII',
    'EducationalStream': '',
    'ExamName': '',
    'UniversityName': '',
    'ExamYear': '',
    'ExamMonth': '',
    'ExamSeatNo': '',
    'MarksObtained': null,
    'OutOfMarks': null,
    'ExamPercentage': null,
    'ExamGrade': '',
    'SchoolName': ''
  },
  {
    'EducationalDetailID': 3,
    'EducationType': 'Diploma',
    'EducationalStream': '',
    'ExamName': '',
    'UniversityName': '',
    'ExamYear': '',
    'ExamMonth': '',
    'ExamSeatNo': '',
    'MarksObtained':null,
    'OutOfMarks': null,
    'ExamPercentage':null,
    'ExamGrade': '',
    'SchoolName': ''
  },
  {
    'EducationalDetailID': 4,
    'EducationType': 'UG',
    'EducationalStream': '',
    'ExamName': '',
    'UniversityName': '',
    'ExamYear': '',
    'ExamMonth': '',
    'ExamSeatNo': '',
    'MarksObtained': null,
    'OutOfMarks':null,
    'ExamPercentage': null,
    'ExamGrade': '',
    'SchoolName': ''
  },
  {
    'EducationalDetailID': 5,
    'EducationType': 'PG',
    'EducationalStream': '',
    'ExamName': '',
    'UniversityName': '',
    'ExamYear': null,
    'ExamMonth': '',
    'ExamSeatNo': '',
    'MarksObtained': null,
    'OutOfMarks': null,
    'ExamPercentage': null,
    'ExamGrade': '',
    'SchoolName': ''
  },
  {
    'EducationalDetailID': 6,
    'EducationType': 'MPhil',
    'EducationalStream': '',
    'ExamName': '',
    'UniversityName': '',
    'ExamYear': null,
    'ExamMonth': '',
    'ExamSeatNo': '',
    'MarksObtained': null,
    'OutOfMarks': null,
    'ExamPercentage': null,
    'ExamGrade': '',
    'SchoolName': ''
  }
];

let commonDocumentGrid = [
  {
    "caption": '#',
    "dataField": "#",
    "width": '5%',
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Document Name',
    "dataField": "DocumentName",
    "width": "65%",
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Select',
    "dataField": "Select",
    "width": "15%",
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": 'Upload',
    "dataField": "Upload",
    "width": "15%",
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },

];

let commonDocuments = [
  {
    '#': 1,
    'DocumentName': 'S.S.C. Certificate',
    'Select': '<input type="checkbox" name="sscSelect" class="checkbox" id="checkbox1"/><label for="checkbox1"></label>',
    'Upload': '<label for="file-upload-1" class="custom-file-upload btn btn-info m-btn m-btn--custom btn-sm m-btn-body">Upload</label><input name="sscFile" id="file-upload-1" type="file"/>'
  },
  {
    '#': 2,
    'DocumentName': 'H.S.C. Certificate',
    'Select': '<input type="checkbox" name="hscSelect" class="checkbox" id="checkbox2"/><label for="checkbox2"></label>',
    'Upload': '<label for="file-upload-2" class="custom-file-upload btn btn-info m-btn m-btn--custom btn-sm m-btn-body">Upload</label><input name="hscFile" id="file-upload-2" type="file"/>'
  },
  {
    '#': 3,
    'DocumentName': 'Income Certificate',
    'Select': '<input type="checkbox" name="incomeSelect" class="checkbox" id="checkbox3"/><label for="checkbox3"></label>',
    'Upload': '<label for="file-upload-3" class="custom-file-upload btn btn-info m-btn m-btn--custom btn-sm m-btn-body">Upload</label><input name="incomeFile" id="file-upload-3" type="file"/>'
  },
];
@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http : HttpClient,private Configuration:Configuration) { }
  getTabs(): Tab[] {
    return tabs;
  }
  getTabsMarathi(): Tab[] {
    return tabsMarathi;
  }
  getSocialReservation() {
    return socialreservation;
  }
  getGridColumns() {
    return gridColumns;
  }

  getEducationalDetails() {
    return educationaldetails;
  }
  getEducationalDetailGridColumns() {
    return edugridColumns;
  }
  getCommonDocumentGridColumns() {
    return commonDocumentGrid;
  }
  getCommonDocuments() {
    return commonDocuments;
  }
  addEducationalDetails(data: EducationalDetails) {
    data.EducationalDetailID = educationaldetails.length + 1;
    educationaldetails.push(data);
  }
  saveEducationalDetails(data: EducationalDetails) {

  }
  deleteEducationalDetails(data: EducationalDetails) {
    if (educationaldetails.filter(d => d.EducationType == data.EducationType).length == 1) {
      let e = educationaldetails.find(d => d.EducationalDetailID == data.EducationalDetailID);
      let index = educationaldetails.indexOf(e);
      educationaldetails[index] = {
        'EducationalDetailID': e.EducationalDetailID,
        'EducationType': e.EducationType,
        'EducationalStream': '',
        'ExamName': '',
        'UniversityName': '',
        'ExamYear': null,
        'ExamMonth': '',
        'ExamSeatNo': '',
        'MarksObtained': null,
        'OutOfMarks': null,
        'ExamPercentage': null,
        'ExamGrade': '',
        'SchoolName': ''
      };
    } else {
      let i = educationaldetails.length;
      while (i--) {
        if (educationaldetails[i].EducationalDetailID === data.EducationalDetailID) {
          educationaldetails.splice(i, 1);
        }
      }
    }
  }
  uploadFile(fileToUpload: File,StudentID: number) {
    debugger

    const endpoint = this.Configuration.serverWithApiUrl +'PreStudentAddressInfo/UploadStudentPhoto?StudentID='+ StudentID; 
    const formData: FormData = new FormData();
    formData.append('Image', fileToUpload, fileToUpload.name);
    formData.append('ImageCaption', "Test");
    return this.http
      .post(endpoint, formData);
  }

  postFile(caption: string, fileToUpload: File, StudentID: number  ) {
      
       const endpoint = this.Configuration.serverWithApiUrl +'PreStudentAddressInfo/UploadStudentPhoto?StudentID='+ StudentID; 
       const formData: FormData = new FormData();
      formData.append('Image', fileToUpload, fileToUpload.name);
      formData.append('ImageCaption', caption);
      return this.http
        .post(endpoint, formData);
  } 

  postFileSign(caption: string, fileToUpload: File, StudentID: number) {
   
     const endpoint = this.Configuration.serverWithApiUrl +'PreStudentAddressInfo/PostStudentSign?StudentID='+ StudentID ; 
 
    const formData: FormData = new FormData();
    formData.append('Image', fileToUpload, fileToUpload.name);
    formData.append('ImageCaption', caption);
    return this.http
      .post(endpoint, formData);
} 


  getUserPassword() {
    return '123456';
    
  }
}


